import { useState, useEffect } from "react"
import Layout from "../../Frames/Layout"
import { Stack, Alert } from "@mui/material"
import API from "../../../services/API"
import Loader from "../../Tools/Loader"
import { useParams } from "react-router-dom"
import Top from "./Top"
import Cards from "./Cards"
import Kpis from "./Kpis"
import Enrollments from "./Enrollments"
import { txt } from "../../../services/translation"

export default function Index(){

    const {id} = useParams()

    const [data, setData] = useState(null)

    useEffect(() => {

        API.get(`/companies/me/users/${id}`)
            .then(r => setData(r.data))
            .catch(e => setData(false))

    }, [id])


    return <Layout tab='company' menu='main'>

        {data && 
            <Stack spacing={3} sx={{mt: 3}}>

                <Top data={data} />

                <Cards data={data} />

                <Kpis data={data } />

                <Enrollments data={data}/>

            </Stack>
        }

        {data === null && <Loader />}

        {data === false && 
            <Alert severity='error'>{txt('contactLoadError')}</Alert>
        }

    </Layout>
}